import { PresignedUrlPayload } from '@zonofi/common';
import {
  getCurrentChannelId,
  getUserId,
  useAppSelector,
  useGetSignUrlMutation,
} from '@zonofi/seller-rtk-store';

export const useGetPresignedUrl = () => {
  const [getPresignedUrlApi] = useGetSignUrlMutation();
  const channel = useAppSelector(getCurrentChannelId);
  const userId = useAppSelector(getUserId);

  const getPresignedUrl = async ({
    cntType,
    name,
    messageId,
    method,
    channelId = channel,
    type,
  }: PresignedUrlPayload) => {
    const presignedUrlResponse = await getPresignedUrlApi({
      fileName: `/${name}`,
      type: type ?? cntType,
      contentType: cntType,
      destination: 'channels',
      method,
      userId,
      channelId,
      messageId,
    }).unwrap();
    const presignedUrl = presignedUrlResponse.presignedUrl;
    return presignedUrl;
  };

  return { getPresignedUrl };
};
